import React from 'react'
import { HeadingBlock, HeadingSubtitle, HeadingTitle } from './PageHeading.styles'

interface PageHeadingProps {
	title: string
	/** Count / context line under the title, e.g. "3 flights". */
	subtitle?: string
}

/**
 * The standard section-page heading: display-font title over a muted count
 * line. One atom for the member section pages (flights, accommodations,
 * files) and the public section pages, so the two surfaces can't drift.
 * Layout (header rows, action buttons, spacing) belongs to the caller.
 */
const PageHeading: React.FC<PageHeadingProps> = ({ title, subtitle }) => (
	<HeadingBlock>
		<HeadingTitle>{title}</HeadingTitle>
		{subtitle && <HeadingSubtitle>{subtitle}</HeadingSubtitle>}
	</HeadingBlock>
)

export default PageHeading
